import { ePageBaseStatus } from "../../../models/ePageBaseStatus"
import { IThangDiemActions } from "../../action-types/IThangDiemActionType"
import { IThangDiemReducer } from "../../page-state-model/so-diem/IThangDiemReducer"

const iniState: IThangDiemReducer = {
    status: ePageBaseStatus.is_not_initialization,
    thangDiems: [],
    truongId: 0
}
export const thangDiemReducer = (state: IThangDiemReducer = iniState, action: IThangDiemActions): IThangDiemReducer => {
    switch (action.type) {
        case "THANG_DIEM_CHANGE_TRUONG_ID":
            return {
                ...state,
                truongId: action.payload,
                status: ePageBaseStatus.is_need_reload
            }
        case "THANG_DIEM_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "THANG_DIEM_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                thangDiems: action.payload
            }
        case "THANG_DIEM_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }
        case "THANG_DIEM_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                thangDiemEditing: action.payload
            }
        case "THANG_DIEM_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "THANG_DIEM_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "THANG_DIEM_SAVE_SUCCESS":
            return {
                ...state,
                isShowEditModal: false,
                status: ePageBaseStatus.is_need_reload
            }
        case "THANG_DIEM_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }
        case "THANG_DIEM_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "THANG_DIEM_DELETE_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload
            }
        case "THANG_DIEM_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }
        default:
            return state;
    }
}
